// web/src/api/dashboard/DashboardAPI.ts
import { AxiosInstance, AxiosResponse } from 'axios';

import { SetTotalPortfolioValueAndSparkDataPayload } from './../../store/dashboard/actions';

export default class DashboardAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getDashboardData(userId: string) {
    return this.client.get(
      `/dashboard/get-initial-dashboard-data?user_id=${userId}`,
    );
  }
  async getClosestTradeValuationDate(
    date: string,
  ): Promise<AxiosResponse<{ data: { value_date: string } }>> {
    return this.client.get(
      `/v2/dashboard/closest-trade-valuation-date/${date}`,
    );
  }
  async getTotalPortfolioValue(data: { currencyId: number; date: string }) {
    return this.client.post('/v2/dashboard/total-portfolio-value/', {
      currency_id: data.currencyId,
      date: data.date,
    });
  }

  async getCounterPartyHedgedNotionals(data: { currencyId: number }) {
    return this.client.post('/v2/dashboard/counterparty-hedged-notionals/', {
      currency_id: data.currencyId,
    });
  }

  async getCounterPartyExposure(data: { currencyId: number }) {
    return this.client.post('/v2/dashboard/counterparty-exposure/', {
      currency_id: data.currencyId,
    });
  }

  async getPortfolioOverallDebt(data: { currencyId: number }) {
    return this.client.post('/v2/dashboard/portfolio-overall-debt/', {
      currency_id: data.currencyId,
    });
  }

  async getPortfolioOverallNotionals(data: { currencyId: number }) {
    return this.client.post('/v2/dashboard/portfolio-overall-notionals/', {
      currency_id: data.currencyId,
    });
  }

  async getTotalPortfolioValueAndSparkData(
    payload: SetTotalPortfolioValueAndSparkDataPayload,
  ) {
    return this.client.post(
      '/v2/dashboard/total-portfolio-value-spark/',
      payload,
    );
  }
}
